import React, { useState } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory from 'react-bootstrap-table2-filter';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import paginationFactory, {
	PaginationProvider
} from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'App.css';
import Spinner from 'Common/Spinner';
import * as JSFuntion from 'Common/Scripts';
import DataTable from 'Common/Table/DataTable';

const AppointeeDatatableView = props => {
    const [timSetCSVExportColumns, settimSetCSVExportColumns] = useState([]);
    const [fileSuffix, setFileSuffix] = useState([]);
	let setSelectRowAttributes = '',
		tableKeyField = 'rowId',
        expandRow;

    const horizontalizeAnswers = (data) => {
        setFileSuffix('_horizontal');
        let maxQuestions = 0;
        for (const row of data) {
            if (row.additionalInfo.length > maxQuestions) {
                maxQuestions = row.additionalInfo.length;
            }
        }

        var columnxxs = props.columns;

        var i = 0;
        while (i < columnxxs.length) {
            if (columnxxs[i].qaColumn) {
                columnxxs.splice(i, 1);
            }
            else {
                ++i;
            }
        }
        if (maxQuestions > 0) {
            for (let i = 0; i < maxQuestions; i++) {
                columnxxs.push({ "dataField": 'q'.concat(i + 1), "text": 'Q'.concat(i + 1), "hidden": true, "csvExport": true, "qaColumn": true });
                columnxxs.push({ "dataField": 'a'.concat(i + 1), "text": 'A'.concat(i + 1), "hidden": true, "csvExport": true, "qaColumn": true });
            }
        }
        settimSetCSVExportColumns(columnxxs);

        const results = [];
        for (const row of data) {
            const resultRow = {
                ...row,
            };
            delete resultRow.additionalInfo;

            let entries = null;
            for (let j = 0; j < maxQuestions; j++) {
                resultRow['q'.concat(j + 1)] = '';
                resultRow['a'.concat(j + 1)] = '';
            }

            if (row.additionalInfo) {
                for (let j = 0; j < row.additionalInfo.length; j++) {
                    resultRow['q'.concat(j + 1)] = row.additionalInfo[j].question;
                    resultRow['a'.concat(j + 1)] = row.additionalInfo[j].answer;
                }
            }
            results.push(resultRow);
        }
        return results;
    };
    const verticalizeAnswers = (data) => {
        setFileSuffix('_vertical');
        var columnxxs = props.columns;

        var i = 0;
        while (i < columnxxs.length) {
            if (columnxxs[i].qaColumn) {
                columnxxs.splice(i, 1);
            }
            else {
                ++i;
            }
        }
        columnxxs.push({ "dataField": 'question', "text": 'Question', "hidden": true, "csvExport": true, "qaColumn": true });
        columnxxs.push({ "dataField": 'answer', "text": 'Answer', "hidden": true, "csvExport": true, "qaColumn": true });
        settimSetCSVExportColumns(columnxxs);

        const results = [];
        for (const row of data) {
            let resultRow = {
                ...row,
            };
            delete resultRow.additionalInfo;
            resultRow['question'] = '';
            resultRow['answer'] = '';
            if (row.additionalInfo && row.additionalInfo.length > 0) {
                for (let j = 0; j < row.additionalInfo.length; j++) {
                    let outputRow = {
                        ...resultRow
                    };
                    outputRow['question'] = row.additionalInfo[j].question;
                    outputRow['answer'] = row.additionalInfo[j].answer;
                    results.push(outputRow);
                }
            }
            else {
                results.push(resultRow);
            }
        }
        return results;
    };

    const clearQuestions = (data) => {
        setFileSuffix('');
        var columnxxs = props.columns;

        var i = 0;
        while (i < columnxxs.length) {
            if (columnxxs[i].qaColumn) {
                columnxxs.splice(i, 1);
            }
            else {
                ++i;
            }
        }
        timSetCSVExportColumns(columnxxs);
        return data;
    };


	const questionSchema = [
		{ field: "question", label: "Question", className: "th-td-50" },
		{ field: "answer", label: "Answer", className: "th-td-50" }
	];
				
	if (props.flagDetailsData === false)
	{
		tableKeyField = 'rowId',
		expandRow = 
		{
			renderer: (row, rowIndex) => (
				<>
				</>
			),
			showExpandColumn: false
		};

		setSelectRowAttributes = {
			mode: 'radio',
			clickToSelect: true,
			selected: [0, props.selectedRowId],
			onSelect: props.handleOnSelectRow,
			selectionRenderer: ({ mode, rowIndex, ...rest }) => (
				<input type={mode} aria-label="Select this row" {...rest} />
			),
		};
	}
	else
	{
		tableKeyField = 'niNumber',
		expandRow = 
		{
			renderer: (row, rowIndex) => (
				<DataTable
					dataSource={row.additionalInfo}
					keyField="question"
					schema={questionSchema}
					variant="inner"
				/>	
			),
			expandHeaderColumnRenderer:  ({ isAnyExpands }) => {
				return;
			},
			expandColumnRenderer: ({ expanded, rowKey, expandable }) => {
				if (!expandable) {
					return;
				}
				
					if (expanded)
					{
						return (
							<button 
								className="btn btn-primary" 
								aria-label="Hide this row">
								Hide
							</button>
						)
					}
					else
					{
						return (
							<button 
								className="btn btn-primary" 
								aria-label={`Show the Questions and Answers for ${rowKey}`}>
								Show
							</button>
						)
					}
			},
			showExpandColumn: true
		};

		setSelectRowAttributes = {
			mode: 'radio',
			clickToSelect: false,
			hideSelectColumn: true,
			onSelect: props.handleOnSelectRow
		};
	}

	//_Customized Export.
    const ExportCSVButton = exportProps => {
        const handleClick = () => {

			props.getExportData(exportProps);
		};
		return (
			<div>
				<button
					id="btnExport"
					className="react-bs-table-csv-btn btn btn-default btn btn-primary btn-sm"
					style={{ height: '45px', width: '200px' }}
					onClick={handleClick}
                >
                    {exportProps.label}
				</button>
			</div>
		);
	};

	return (
		<React.Fragment>
			<PaginationProvider
				pagination={paginationFactory({
					custom: true,
					totalSize: props.total,
					page: props.pageNo,
					sizePerPage: props.pageSize,
					showTotal: true,
					withFirstAndLast: true,
					alwaysShowAllBtns: true
				})}
				keyField={tableKeyField}
				columns={props.columns}
				data={props.tableData}
			>
				{({ paginationProps, paginationTableProps }) => (
					<ToolkitProvider
						keyField={tableKeyField}
						columns={props.columns}
						data={props.tableData}
						search={{ placeholder: 'Search...' }}
						exportCSV={{
							fileName: `contract_Management_${props.contractTypes.join('_')}_${JSFuntion.getExportDateTime()}${fileSuffix}.csv`,
							separator: ','
						}}
					>
                        {toolkitProps => {
                            return (
								<div className="container-fluid">
									<div
										style={{
											display: 'flex',
											flexDirection: 'row',
											justifyContent: 'space-between',
											flexWrap: 'wrap'
										}}
									>
									</div>
									<React.Fragment>
										<BootstrapTable
											classes={'table tableStyle table-primary table-striped table-sm table-responsive-md'}
											{...toolkitProps.baseProps}
											{...paginationTableProps}
											remote={{
												pagination: true,
												search: false
											}}
											onTableChange={props.handleTableChange}
											filter={filterFactory()}
											ignoreSinglePage
											bootstrap4
											striped
											condensed
											hover
											size="sm"
											expandRow={expandRow}
										/>
										{!props.apiCallCompleted && <Spinner />}
									</React.Fragment>
									<div
										style={{
											display: 'flex',
											flexDirection: 'row',
											justifyContent: 'space-between',
											flexWrap: 'wrap'
										}}
                                    >
                                        {props.flagDetailsData ? (
                                        [
										<ExportCSVButton
											className="btn btn-primary btn-sm"
											style={{
												height: '45px',
                                                width: '200px',
                                                display: 'table-cell'
                                            }}
                                                label='Export CSV ⬇️'
                                                dynamicFunction={verticalizeAnswers}
                                            {...toolkitProps.csvProps}
										></ExportCSVButton>,
                                        <ExportCSVButton
                                            className="btn btn-primary btn-sm"
                                            style={{
                                                height: '45px',
                                                width: '200px',
                                                display: 'table-cell'
                                            }}
                                            label='Export CSV ➡️'
                                            dynamicFunction={horizontalizeAnswers}
                                            {...toolkitProps.csvProps}
                                        ></ExportCSVButton>
                                        ] )
                                         : (
                                            <ExportCSVButton
                                                className="btn btn-primary btn-sm"
                                                style={{
                                                    height: '45px',
                                                    width: '200px'
                                                }}
                                                label='Export'
                                                dynamicFunction={clearQuestions}
                                                {...toolkitProps.csvProps}
                                            ></ExportCSVButton>
                                        )}
										<div className="SelectButtonCell">
											<button
												id="btnSelect"
												style={{
													height: '45px',
                                                    width: '150px',
													display: 'none'
												}}
												onClick={props.handleSelectClick}
												className="react-bs-table-csv-btn btn btn-default btn btn-primary btn-sm"
											>
												Back
											</button>
										</div>
									</div>
								</div>
							);
						}}
					</ToolkitProvider>
				)}
			</PaginationProvider>
		</React.Fragment>
	);
};

export default AppointeeDatatableView;
